import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DiscordFilledSvg from "@ant-design/icons-svg/es/asn/DiscordFilled";
import AntdIcon from '../components/AntdIcon';
var DiscordFilled = function DiscordFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: DiscordFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(DiscordFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'DiscordFilled';
}
export default RefIcon;